import {
  Button,
  Dropdown,
  Empty,
  Input,
  Space,
  Table,
  Tag,
  Tooltip,
} from "antd";
import { useEffect, useState } from "react";
import { gatewayCRUD } from "../../../../actions/gateway";
import { char, number } from "../../../../utils";
import moment from "moment";
import {
  MoreOutlined,
  CheckCircleOutlined,
  PercentageOutlined,
} from "@ant-design/icons";
import { StudentInvoiceClearanceAdd, StudentInvoiceDiscountAdd } from "./add";

export const StudentInvoice = (props) => {
  const { dataId } = props;
  const [openClearance, setOpenClearance] = useState(false);
  const [openDiscount, setOpenDiscount] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [invoId, setInvoId] = useState(null);
  const [invoAmount, setInvoAmount] = useState(0);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    if (dataId) {
      setLoading(true);
      setTimeout(() => {
        gatewayCRUD
          .loadCustomerInvoice(dataId)
          .then((resp) => {
            setData(resp.data?.results);
          })
          .catch(() => {
            setData([]);
          })
          .finally(() => {
            setLoading(false);
          });
      }, 500);
    }
  }, [dataId]);

  const columns = [
    {
      title: "Date",
      dataIndex: "control_number_date",
      width: 120,
      ellipsis: true,
      render: (text) => (
        <span>{text ? moment(text).format("DD MMM YYYY") : "N/A"}</span>
      ),
    },
    {
      title: "Control Number",
      dataIndex: "control_number",
      width: 120,
      ellipsis: true,
      render: (text) => (
        <Tooltip title={text}>
          <span className="ellipsis-cell">{text}</span>
        </Tooltip>
      ),
    },
    {
      title: "Expiry Date",
      dataIndex: "control_number_expiry_date",
      width: 120,
      ellipsis: true,
      render: (text) => (
        <span>{text ? moment(text).format("DD MMM YYYY") : "N/A"}</span>
      ),
    },
    {
      title: "Payment Option",
      dataIndex: "payment_type",
      width: 100,
      ellipsis: true,
      render: (text) => (
        <Tooltip title={char.toTitleCase(text)}>
          <span className="ellipsis-cell">{char.toTitleCase(text)}</span>
        </Tooltip>
      ),
    },
    {
      title: "Currency",
      dataIndex: "bill_currency",
      width: 100,
      ellipsis: true,
      render: (text) => (
        <Tooltip title={text}>
          <span className="ellipsis-cell">{text}</span>
        </Tooltip>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      width: 120,
      align: "right",
      render: (text) => <span>{number.fNumberDoublePoint(text)}</span>,
    },
    {
      title: "Description",
      dataIndex: "bill_description",
      width: 180,
      ellipsis: true,
      render: (text) => (
        <Tooltip title={char.smartTitleCase(text)}>
          <span className="ellipsis-cell">{char.smartTitleCase(text)}</span>
        </Tooltip>
      ),
    },
    {
      title: "Status",
      dataIndex: "is_paid",
      width: 100,
      render: (paid) => (
        <Tag color={paid ? "green" : "red"}>{paid ? "Paid" : "Not Paid"}</Tag>
      ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 50,
      render: (record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: "Discount",
                key: "discount",
                icon: <PercentageOutlined />,
              },
              {
                label: "Clearance",
                key: "clearance",
                icon: <CheckCircleOutlined />,
              },
            ],
            onClick: (event) => {
              switch (event.key) {
                case "clearance":
                  setOpenClearance(true);
                  setInvoId(record.id);
                  break;
                case "discount":
                  setOpenDiscount(true);
                  setInvoId(record.id);
                  setInvoAmount(record.amount);
                  break;
                default:
              }
            },
          }}
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
        >
          <Space>
            <Button type="dashed" icon={<MoreOutlined />} size={"small"} />
          </Space>
        </Dropdown>
      ),
    },
  ];

  const filteredData = data?.filter((item) => {
    if (!filter) return true;

    return String(item.control_number)
      .toLowerCase()
      .includes(String(filter).toLowerCase());
  });

  return (
    <>
      <div className="container-fluid">
        <div className="row mt-4">
          <div className="col-md-2 col-sm-6">
            <Input
              placeholder="Search by control number..."
              allowClear
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-12">
            <Table
              columns={columns}
              dataSource={filteredData}
              size="small"
              rowKey="control_number"
              bordered
              pagination={false}
              loading={loading}
              scroll={{
                x: 900,
                y: "60vh",
              }}
              locale={{
                emptyText: <Empty description="No data available" />,
              }}
              className="custom-payment-table"
            />
          </div>
        </div>
      </div>
      <StudentInvoiceClearanceAdd
        open={openClearance}
        setOpen={setOpenClearance}
        dataId={invoId}
      />
      <StudentInvoiceDiscountAdd
        open={openDiscount}
        setOpen={setOpenDiscount}
        dataId={invoId}
        dataAmount={invoAmount}
      />
    </>
  );
};
